const DotSymbol = "•";
const Rupee = "₹";

export { DotSymbol, Rupee };
//# sourceMappingURL=symbol.js.map
